import { createContext, Dispatch, SetStateAction } from 'react';

interface AgreementAndApprovalsContextType {
  isAdvancePaymentCalculating: boolean;
  setIsAdvancePaymentCalculating: Dispatch<SetStateAction<boolean>>;
  isEditMode: boolean;
  setIsEditMode: Dispatch<SetStateAction<boolean>>;
}

export const AgreementAndApprovalsContext = createContext<
  AgreementAndApprovalsContextType | undefined
>(undefined);
